module.exports = __webpack_public_path__ + "media/1975-2020.a3cf72ba.mp4";